import { render, staticRenderFns } from "./kindChooseViewzbSeventh.vue?vue&type=template&id=f6b79ee2&scoped=true"
import script from "./kindChooseViewzbSeventh.vue?vue&type=script&lang=js"
export * from "./kindChooseViewzbSeventh.vue?vue&type=script&lang=js"
import style0 from "./kindChooseViewzbSeventh.vue?vue&type=style&index=0&id=f6b79ee2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b79ee2",
  null
  
)

export default component.exports